/**
 * BMRCL dynamic-QR assembly.
 *
 * The gate QR is the static authorization token joined (with "#") to a dynamic
 * block carrying the current epoch as hex seconds. The gate compares that
 * timestamp to its OWN system clock and NACKs the QR when the difference exceeds
 * 30s, so the client must regenerate the dynamic block every few seconds against
 * a server-synced clock. Both functions are pure (no Date/DOM) so they stay
 * trivially testable; the component owns the timer + clock offset.
 */

/**
 * hexEpochSeconds renders an epoch-ms instant as lowercase 32-bit hex SECONDS
 * (e.g. 1587475074000 -> "5e9ef282"), zero-padded to 8 digits to match BMRCL's
 * fixed-width 32-bit parsing. `>>> 0` forces unsigned 32-bit (matches the gate).
 */
export function hexEpochSeconds(nowMs: number): string {
  return (Math.floor(nowMs / 1000) >>> 0).toString(16).padStart(8, '0');
}

/**
 * buildDynamicQrValue assembles the full gate-QR payload:
 *   `<staticBlock>#{<hex>||<lat>|<lng>|}`
 * QR_Status and Operator_Specific_Data are left empty per BMRCL's spec.
 */
export function buildDynamicQrValue(
  staticBlock: string,
  hex: string,
  lat: string,
  lng: string
): string {
  return `${staticBlock}#{${hex}||${lat}|${lng}|}`;
}
